<template>
  <div class="whitelabel-test p-3">
    <h3>Whitelabel Test</h3>
    <div class="mb-3">
      <strong>Is Whitelabel Enabled:</strong> {{ isWhitelabelEnabled }}
    </div>
    <div class="mb-3">
      <strong>Primary Color:</strong> {{ primaryColor }}
    </div>
    <div class="mb-3">
      <strong>Whitelabel Logo:</strong> {{ whitelabelLogo }}
    </div>
    <div class="mb-3">
      <strong>Logo Source:</strong> {{ logoSource }}
    </div>
    <div class="mb-3">
      <strong>Terminal DB Settings:</strong>
      <pre>{{ JSON.stringify(terminal && terminal.db_settings, null, 2) }}</pre>
    </div>
    <div class="mb-3">
      <strong>CSS Custom Properties:</strong>
      <div>--primary-color: {{ cssPrimaryColor }}</div>
      <div>--primary-color-rgb: {{ cssPrimaryColorRgb }}</div>
    </div>
    <div class="mb-3">
      <button
        @click="testWhitelabel"
        class="btn btn-primary"
      >
        Test Whitelabel Theme
      </button>
      <button
        @click="resetTheme"
        class="btn btn-secondary ml-2"
      >
        Reset Theme
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { updateWhitelabelTheme, resetWhitelabelTheme } from '@/helpers/whitelabelHelper';

export default {
  name: 'WhitelabelTest',
  computed: {
    ...mapGetters({
      isWhitelabelEnabled: 'config/isWhitelabelEnabled',
      primaryColor: 'config/primaryColor',
      whitelabelLogo: 'config/whitelabelLogo',
      terminal: 'config/terminal'
    }),
    logoSource() {
      return this.isWhitelabelEnabled && this.whitelabelLogo ? this.whitelabelLogo : "../assets/images/logo.svg";
    },
    cssPrimaryColor() {
      if (typeof document !== 'undefined') {
        return getComputedStyle(document.documentElement).getPropertyValue('--primary-color');
      }
      return 'N/A';
    },
    cssPrimaryColorRgb() {
      if (typeof document !== 'undefined') {
        return getComputedStyle(document.documentElement).getPropertyValue('--primary-color-rgb');
      }
      return 'N/A';
    }
  },
  methods: {
    testWhitelabel() {
      updateWhitelabelTheme('#FF0000');
    },
    resetTheme() {
      resetWhitelabelTheme();
    }
  }
};
</script>

<style scoped>
.whitelabel-test {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 5px;
}
</style>
